import { FolderPage } from '#folder_page.tsx';
import { folders } from '#folders.ts';
import { Navigate, Route, Routes } from 'react-router';

export const App: React.FC = () => {
	return (
		<Routes>
			<Route index element={<Navigate replace to={folders[0].folderName} />} />
			{folders.map((folder) => (
				<Route
					key={folder.folderName}
					path={folder.folderName}
					element={<FolderPage folder={folder} />}
				/>
			))}
		</Routes>
	);
};
